import React, { Component } from 'react';
import {connect} from 'react-redux';
import {Route, Switch, withRouter} from "react-router";
import SetUserPasswordHOC from "../containers/setUserPasswordHOC";
import RoleRouter from "./roleRouter";
import ForgotPasswordHOC from "../containers/forgotPasswordHOC";
import Authentication from "../containers/authenticationHOC";
import GoogleAnalyticsHOC from "../containers/General/GoogleAnalyticsHOC";

class AuthRouter extends Component {

    render() {

        let renderComp;
        if(this.props.isAuth){
            renderComp = <Switch>
                <Route exact path="/set-password" component={SetUserPasswordHOC}/>
                <Route path="/" component={RoleRouter}/>
            </Switch>
        }
        else {
            renderComp = <Switch>
                <Route exact path="/forgot-password" component={ForgotPasswordHOC}/>
                <Route exact path="/set-password" component={SetUserPasswordHOC}/>
                <Route path="/" component={Authentication(['Administrator','User','Solicitor','Broker','Underwriter','Cmu'])(RoleRouter) }/>
            </Switch>
        }

        return (
            <div>
                {renderComp}
            </div>
        )

    }
}

const mapStateToProps = (state) => {
    return {
        isAuth: !!state.user.loggedInUser.id
    }
};

const mapDispatchToProps = (dispatch) => {
    return {}
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GoogleAnalyticsHOC(AuthRouter)));